import React, {useContext} from 'react';

import {Integer} from '@pb/kit-component-formatters';
import {Group} from '@pb/kit-component-group';
import {LocaleContext} from '@pb/kit-context-locale';

type Props = {
    value?: number,
};

export const FileSizeCell = ({value}: Props) => {
    const {locale} = useContext(LocaleContext);

    if (!value) {
        return <div/>;
    }

    return (
        <Group gap="xs">
            <span>{Integer.format(value / 1000, locale)}</span>
            <span>KB</span>
        </Group>
    );
};
